import get from 'lodash.get'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Payload = Record<string, any>

const regEx1 = /loading chunk (\d+) failed after 10 retries\./gi
const regEx2 = /loading css chunk (\d+) failed\./gi

const filterApmErrors = (payload: Payload): Payload | boolean | void => {
  const errors = get(payload, 'errors', [])
  const message: string = get(errors, '[0].exception.message', '')

  if (errors.length === 0) return payload

  if (message.match(regEx1)) return false
  if (message.match(regEx2)) return false
  if (message.includes('ResizeObserver loop limit exceeded')) return false
  if (message.includes('ResizeObserver loop completed')) return false
  if (message.includes('Script error')) return false
  if (message.includes('factors is not defined')) return false
  if (message.includes('heap is not defined')) return false
  if (message.includes("Can't find variable: factors")) return false
  if (message.includes("Can't find variable: heap")) return false
  if (message.includes('Unhandled promise rejection')) return false

  return payload
}

export default filterApmErrors
